import * as um from 'generated/api/um.api';

type GetUserInfo = um.paths['/open-api/users/{id}'];
export type GetUserInfoParams = GetUserInfo['get']['parameters']['path']['id'];
export type UserInfo = GetUserInfo['get']['responses']['200']['schema'];
